import { get } from 'lodash';

const transactionReadPath = 'actionsAvailable./account/transactions/read';
const paymentReadPath = 'actionsAvailable./account/payments/read';
export const transactionReadCapability = '/account/transactions/read';
export const paymentReadCapability = '/account/payments/read';
// const transactionWritePath = 'actionsAvailable./account/transactions/write';
const createPaymentPath = 'actionsAvailable./account/payments/uk/default/out';
const createIFTPaymentPath = 'actionsAvailable./account/payments/ift/out';

const getAccounts = (state) => state.accounts;

const paymentReadFilter = (account) =>
	get(account, paymentReadPath, false) && !get(account, transactionReadPath, false);
const transactionReadFilter = (account) => get(account, transactionReadPath, false);

const formatAccount = (account = {}) => ({
	account_number: account.accountNumber,
	sort_code: account.sortCode,
	name: account.displayName,
	account_uuid: account.id,
	account_holder: account.metadata.account_name,
});

export const getAccountsWithPaymentReadAction = (state) => {
	const accounts = getAccounts(state);
	return accounts.filter(paymentReadFilter);
};

export const getAccountsWithTransactionRead = (state) => {
	const accounts = getAccounts(state);
	return accounts.filter(transactionReadFilter);
};

export const getAccountRights = (state, { account_number: accountNumber = '', account_uuid = '' }) => {
	const account = state.accounts.find((account) => {
		if (account_uuid) return account.id === account_uuid;
		return account.accountNumber === accountNumber;
	});

	if (account) {
		return {
			read: get(account, transactionReadPath, false),
			create: get(account, createPaymentPath, false) || get(account, createIFTPaymentPath, false),
		};
	}

	return { read: false, create: false };
};
export const getAccountById = (state, account_uuid) => {
	const account = state.accounts.find((account) => account.id === account_uuid);
	if (account) {
		if (account.type === 'credit_card') {
			return {
				account_number: account.number,
				sort_code: '',
				name: account.displayName,
				account_uuid: account.id,
			};
		}
		return formatAccount(account);
	}
	return undefined;
};

export const getAccountByAccountNumber = (state, accountNumber = '') => {
	const account = state.accounts.find((account) => account.accountNumber === accountNumber);
	if (account) {
		return formatAccount(account);
	}
	return account;
};

export const getAccountByAccountNoAndSortCode = (state, { accountNumber = '', sortCode = '' }) => {
	const account = state.accounts.find(
		(account) => account.accountNumber === accountNumber && account.sortCode === sortCode
	);

	if (account) {
		return formatAccount(account);
	}
	return undefined;
};

export const getAccountIdByAccountNo = (state, accountNumber = '') => {
	const account = getAccountByAccountNumber(state, accountNumber);

	return get(account, 'account_uuid', null);
};
